import React, {useState, useMemo, useCallback, useContext} from 'react';
import axios from 'axios';
import config from '../../../config';
import { AuthContext } from '../../../contexts/authContext';
import './Update.css';
import { useDropzone } from 'react-dropzone';
import CircleProgress from '../../../components/CircleProgress/CircleProgress';
import useNotification from '../../../hooks/useNotification';

const baseStyle = {
    //flex: 1,
    width: '230px',
    height: '90px',
    //marginLeft: '50px',
    display: 'flex',
    fontSize: '14px',
    flexDirection: 'column',
    alignItems: 'center',

    //padding: '50px',
    borderWidth: 3,
    borderRadius: 5,
    borderColor: '#aaaaaa',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const focusedStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};

function Update(props) {
    const auth = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const { notificationSuccess, notificationError, notificationInfo } = useNotification();

    const updatePanelsAndStops = async(file, props) => {
        try {
            setLoading(true);
            const essentialData = {
                city: props.city
            }

            let form = new FormData();

            form.append('essentialData', JSON.stringify(essentialData));

            form.append('file', file);


            const axiosParams = {
                url: '/update-stops-panels',
                method: 'post',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                data: form
            };

            await axios(axiosParams);
            notificationSuccess('Impianti e Fermate aggiornati');
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logout();
            } else {
                if (typeof error.response.data.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError("Errore nell'aggiornamento");
                }
            }
            setLoading(false);
        }
    }

    const onDrop = useCallback(async(acceptedFiles) => {
        //devo prendere il file e renderlo base64 per poi storarlo
        if(acceptedFiles.length===0){
            notificationInfo('Sono accetti solo file in formato .csv');
            return;
        }
        await updatePanelsAndStops(acceptedFiles[0], props);
    }, []);

    const {
        /* acceptedFiles, */
        getRootProps,
        getInputProps,
        open,
        isFocused,
        isDragAccept,
        isDragReject
    } = useDropzone({onDrop, accept: {'text/csv':['.csv'] },  multiple: false/* , maxFiles: 1, maxSize: 31457280 */});

    const dropZonestyle = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);

    return (
        <>{loading && <CircleProgress isDialog/>}
        <div className='component-container update'>
            <div className='component-card'>
                <div className='box'>
                    <div className="dropBox" {...getRootProps({style: dropZonestyle})}>
                        <input {...getInputProps()} />
                        <p style={{textAlign: "center"}}>Clicca per caricare il csv</p>
                        <p style={{textAlign: "center"}}>Oppure trascina qui</p>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Update